






















import Vue from 'vue'
import detailsComponent from "../..//components/connections/ConnectionDetailsPanel.vue"

export default Vue.extend( {
  name: "ConnectionDetail",
  components: {
    detailsComponent
  },
  data: function () {
    return {
      itemId: 0,
    }
  },
  methods: {
    loadData() {

      console.log("*** Start loadData");

      this.getItemId();

      console.log("*** End loadData");

    },
    getItemId() {

      let paramId = this.$route.params.id;

      if (paramId === undefined) {
        this.itemId = 0;
      } else {
        this.itemId = parseInt(paramId);
      }

      console.log("itemId: " + this.itemId);

    }
  },
  mounted: function () {
    this.loadData();
  }
})
